import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import {closeModal} from '../../ducks/ui';

import Modal from './Modal';
import Button from '../button/Button';
import SocialIcon from '../socialIcon/SocialIcon';

@injectIntl
@connect()
export default class ContactModal extends React.PureComponent {
  static modalName = 'contact';

  constructor(props) {
    super(props);
  }

  openIntercom = (message) => {
    const {dispatch} = this.props;

    dispatch(closeModal());

    if (window.Intercom) {
      window.Intercom('showNewMessage', message);
    }
  }

  render() {
    const {intl, ...rest} = this.props;

    const chatMessage = 'Hello, I have some questions regarding my recent order. Could you please assist me with this?';

    return (
      <Modal {...rest}>
        <div className="modal__column  modal__column--social">
          <div className="modal__header">
            <FormattedMessage id="section.contact-us.title"/>
          </div>

          <p className="modal__text">
            <FormattedMessage id="section.contact-us.description"/>
          </p>

          <Button
            full iconed filled
            onClick={() => this.openIntercom(chatMessage)}
          >
            <SocialIcon network="intercom"/><FormattedMessage id="page.product.chat-with-us" />
          </Button>

          <Button
            full iconed mod="discord"
            component="a"
            href="https://discord.com/invite/d5ZW2Ecwdt"
            target="_blank"
            rel="nofollow"
          >
            <SocialIcon network="discord"/><FormattedMessage id="section.contact-us.join-discord"/>
          </Button>

          <p className="modal__text">
            <FormattedMessage id="section.contact-us.or-email"/>
            {' '}
            <a href="mailto:support@boosthive.eu" target="_blank" rel="nofollow">support@boosthive.eu</a>
          </p>
        </div>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./components/modals/ContactModal.js